import React, { useState, useCallback } from 'react'
import { MoreVert } from '@mui/icons-material'
import { IconButton, Menu, MenuItem, styled } from '@mui/material'
import { colorPalette } from '../../../../../../../../style/colorPalette'

interface PageThumbnailMenuButtonProps {
  onDelete: () => void
}

const StyledIconButton = styled(IconButton)({
  position: 'absolute',
  top: '4px',
  right: '4px',
  opacity: 0,
  transition: 'opacity 0.2s ease',
  backgroundColor: colorPalette.monotone[0] + 'E6',
  width: '28px',
  height: '28px',

  '&:hover': {
    backgroundColor: colorPalette.pink[0],
  },

  '&.menu-button': {
    opacity: 0,
  },
})

const StyledIcon = styled(MoreVert)<{ isOpen: boolean }>(
  ({ theme, isOpen }) => ({
    color: isOpen ? colorPalette.monotone[0] : colorPalette.monotone[4],
    transition: theme.transitions.create('color', {
      duration: theme.transitions.duration.short,
    }),
    fontSize: '16px',
  })
)

const StyledMenu = styled(Menu)({
  '& .MuiPaper-root': {
    minWidth: '120px',
    boxShadow: `0 2px 8px ${colorPalette.monotone[10]}26`,
    borderRadius: '8px',
  },
})

const StyledMenuItem = styled(MenuItem)({
  fontSize: '14px',
  padding: '8px 16px',
  color: colorPalette.pink[6],

  '&:hover': {
    backgroundColor: colorPalette.pink[1],
  },
})

export const PageThumbnailMenuButton: React.FC<
  PageThumbnailMenuButtonProps
> = ({ onDelete }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const isMenuOpen = Boolean(anchorEl)

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    event.preventDefault()
    setAnchorEl(event.currentTarget)
  }

  const handleMenuClose = useCallback(() => {
    setAnchorEl(null)
  }, [])

  const handleDelete = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation()
      handleMenuClose()
      onDelete()
    },
    [handleMenuClose, onDelete]
  )

  return (
    <>
      <StyledIconButton
        className="menu-button"
        onClick={handleMenuOpen}
        aria-label="ページメニュー"
      >
        <StyledIcon isOpen={isMenuOpen} />
      </StyledIconButton>

      <StyledMenu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <StyledMenuItem onClick={handleDelete}>削除</StyledMenuItem>
      </StyledMenu>
    </>
  )
}
